import angular from 'angular';

export function NotificationService($timeout, NOTIFICATION_CONSTS) {
    let registeredPlaceholder = null;

    const showMessage = async (message, waitUntilDisappear) => {
        if (registeredPlaceholder) {
            registeredPlaceholder.addMessage(message);
            if (waitUntilDisappear) {
                const delayPromise = new Promise(resolve => setTimeout(resolve, NOTIFICATION_CONSTS.DEFAULT_DURATION || 0));
                await delayPromise;
            }
        } else {
            throw new Error('Need to be registered a placeholder');
        }
    };

    const registerPlaceholder = (placeholder) => {
        if (!registeredPlaceholder) {
            registeredPlaceholder = placeholder;
        } else {
            throw new Error('Notification placeholder already registered');
        }
    };

    const success = (text, waitUntilDisappear) => showMessage({ type: NOTIFICATION_CONSTS.TYPE.SUCCESS, text }, waitUntilDisappear);

    const warning = text => showMessage({ type: NOTIFICATION_CONSTS.TYPE.WARNING, text });

    const error = text => showMessage({ type: NOTIFICATION_CONSTS.TYPE.ERROR, text });

    return {
        success,
        warning,
        error,
        registerPlaceholder,
    };
}

angular.module('TALENYA-FE').factory('NotificationService', NotificationService);
